export default "__VITE_ASSET__of3RS3JP__"